import React, { Component } from "react";

class Video extends Component {
  title = "";
  url = "#";

  render() {
    return (
      <a
        href={`https://www.youtube.com/watch?v=${this.props.url}`}
        target="_blank"
        rel="noopener noreferrer"
        title={this.props.title}
      >
        <span></span> Voir la vidéo : {this.props.title}
      </a>
    );
  }
}

export default Video;
